<template lang="pug">
  b-card.border-0.customerCard.tempInput.overflow-hidden(
    bg-variant="white",
    body-class="p-2",
    @click="selectTempHandler(originalData.id, originalData.type)"
  )
    .text-right.mb-2(
      v-if="deleteMode"
    )
      i.fas.fa-times-circle.fa-lg(
        @click.stop.prevent="deleteTempHandler(originalData.id, originalData.type)"
      )
    .row.mb-2
      .col-2.p-0(
        v-show="selectMode"
      )
        input.custom_checker(
          type="checkbox",
          :id="`checkbox-group-${index}`",
          name="selectTemps",
          :checked="isChecked(index)"
          :class="{ 'hidden-check': isChecked(index) }"
        )
        .input_wrap.ml-3
          .custom-check-icon.border-black.mr-2
      .position-relative.bg-light.p-2(
        :class="{ 'col-10': selectMode, 'col-12': !selectMode }"
      )
        video.img-fluid.w-100.h-100.rounded(
          :poster="originalData.push_format.previewImage ? originalData.push_format.previewImage : null" controls 
        )
          source(
            :src="originalData.push_format.video",
            type="video/mp4"
          )
          source(
            :src="originalData.push_format.video",
            type="video/ogg"
          )
          | Your browser does not support the video tag.
    small.font-size-sm.text-gray 建立者：{{ originalData.creator }} | 影片
    p.font-size-sm.mb-1 模板名稱：{{ originalData.name }}

</template>

<script>
const _ = require('lodash');

export default {
  name: 'video-input',
  props: {
    index: [String, Object, Number],
    // 父層資訊
    originalData: {
      type: Object,
      required: true
    },
    selectMode: {
      type: Boolean,
      default: false
    },
    selectTemps: {
      type: Array,
      default: () => [],
    },
    deleteMode: {
      type: Boolean,
      default: false
    },
    tempTypes: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    selectTempHandler(id, template) {
      const vm = this;
      vm.$emit('selectTempHandler', {
        id,
        template
      });
    },
    deleteTempHandler(id, template) {
      const vm = this;
      vm.$emit('deleteTempHandler', {
        id,
        template
      });
    },
    isChecked(index) {
      const vm = this;
      const key = _.findKey(vm.selectTemps, (val) => val.id === vm.originalData.id && val.type === vm.originalData.type);
      if (key) {
        return true;
      }
      return false;
    }
  },
  computed: {
    order() {
      const vm = this;
      const key = _.findKey(vm.selectTemps, (val) => val.id === vm.originalData.id);
      return parseInt(key);
    },

  }
};
</script>

<style lang="scss" scoped>
.card {
  border: 0.2rem solid #000!important;
  border-radius: 0.8rem;
  box-shadow: 0.2rem 0.2rem 0 #00000033;
  &-hasNews {
    &::after {
      content: "";
      position: absolute;
      right: 0.4rem;
      top: 0.4rem;
      background-color: #ef4852;
      width: 0.7rem;
      height: 0.7rem;
      border-radius: 50%;
    }
  }
}

@font-face {
  font-family: "icon";
  src: url("../../../assets/fonts/icon.eot?hrpp7d");
  src: url("../../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

i {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 1rem;
  margin-bottom: 4px;
}

.iconClose:before {
  content: "\e908";
}

.border-black{
  border: 0.2rem solid #000;
}
.outline-invitation {
  display: block;
  border-radius: 1rem;
  padding: 1rem;
  cursor: pointer;
}
.custom-shadow {
  -webkit-box-shadow: 0.2rem 0.2rem 0 #00000033;
  box-shadow: 0.2rem 0.2rem 0 #00000033;
}

.custom-check-icon {
  width: 2rem;
  height: 2rem;
  background-color: #fff;
  border-radius: 0.4rem;
  margin-right: 1.2rem;
  position: relative;
}

.custom_checker:checked ~ .input_wrap .custom-check-icon {
  background-color: #ef4852;
}

.custom_checker:checked ~ .input_wrap .custom-check-icon::after {
  display: block;
}

.custom-check-icon::after {
  content: '';
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 1.5rem;
  height: 1rem;
  background-image: url(../../../assets/images/icon/check-1.png);
  background-size: 1.5rem;
  background-repeat: no-repeat;
}

.invitation_info {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

input[type="checkbox"], input[type="radio"] {
  position: absolute;
  width: 1px;
  height: 1px;
  display: none;
  opacity: 0;
}
</style>
